export const generateBody = (queryString) => JSON.stringify(createBody(queryString))

export function createBody(queryString) {
  const filters = filtersFromQueryString(queryString);
  const sortField = queryString.SortAsc || queryString.SortDesc;
  const sortOrder = queryString.SortAsc ? "asc" : "desc";
  const sort = sortField ? { sort: [{ [sortField]: { order: sortOrder } }] } : defaultSort();
  const size = 20;
  const from = ((queryString.Page || 1) - 1) * size;

  const body = {
    query: {
      bool: {
        must: filters,
      },
    },
    ...sort,
    size: size,
    from: from,
  };

  return body;
}

function filtersFromQueryString({ Analyst, coveredBy, companyName, email, region, gicsLevel2, currentRating, ...props }) {
  const arr = [
    Analyst && { query_string: { fields: ["coveredBy.en"], query: Analyst } },
    coveredBy && { query_string: { fields: ["coveredBy.*.raw"], query: coveredBy + "*" } },
    companyName && { query_string: { fields: ["companyName.en.raw", "companyName.ja.raw", "ticker", "ric"], query: companyName + "*" } },
    email && { term: {coveredByEmail: email}}, 
    region && { term: { "region.en": region } },
    gicsLevel2 && { term: { "gicsLevel2IndustryGroups.en": gicsLevel2 } },
    currentRating && { term: { currentRating: currentRating } },
    props["analysts.id"] && { term: { analystCategoryID: props["analysts.id"] } },
  ];
  return arr.filter((i) => i); // remove empty filters
}

const defaultSort = () => {
  const sortField = "companyName.en";
  return {
   sort: [{ [sortField]: { order: "asc" }}]
  };
}